import { Button, Grid2, MenuItem, Select, Snackbar, TextField, Typography } from "@mui/material";
import { useEffect, useState } from "react";
import { Label } from "flowbite-react";
import {makeGetRequestToUrl} from '../commonFunc.jsx';
import {makePostRequestToUrl} from '../commonFunc.jsx';
import config from '../../config/config.js';
import { useNavigate } from "react-router-dom";
import TokenError from "../tokenError";

const NoShowSettings = () =>{
    const [isActive, setIsActive] = useState(true);
    const [driverCut, setDriverCut] = useState('');
    const [waitingTime, setWaitingTime] = useState('');
    const [valueType, setValueType] = useState(1);
    const [value, setValue] = useState('');

    const serverUrl = config.serverUrl;
    const operationsUrl = config.operationsUrl;
    const [message, setMessage] = useState('');
    const [snackbar, showSnackbar] = useState(false);
    const [noShowId, setNoShowId] = useState(0);
    const [tokenExpired, setTokenExpired] = useState(false);
    const navigate = useNavigate();
    const clientId = localStorage.getItem('clientId');
    const driver_no_show_fare_disabled = localStorage.getItem('driver_no_show_fare_disabled');

    const fetchNoShowSettings = async() => {
        try {
            const token = localStorage.getItem('token');
            const url = serverUrl + '/settings/fetch_no_show_setting';
            const timestamp = new Date().getTime();
            const body = {
                token: token,
                // client_id: clientId,
                timestamp: timestamp
            };
            const response =  await makeGetRequestToUrl(url, body);
            if(response.flag==200){
                const fetchedData = response.data[0];
                setValueType(fetchedData.is_percentage);
                setIsActive(fetchedData.is_active==0 ? false : true);
                setDriverCut(fetchedData.driver_cut);
                setWaitingTime(fetchedData.waiting_time);
                setNoShowId(fetchedData.id);
                setValue(fetchedData.value);
            }
            if(response.flag==102){
                console.log('Token is expired. Please login again')
                localStorage.removeItem('token');
                setTokenExpired(true);

                setTimeout(() => {
                    navigate('/signup');
                }, 2000);
            }
        } 
        catch (error) {
            console.log('error', error);
        }
    }

    useEffect(()=> {
        fetchNoShowSettings();
    },[])

    const saveData = async() =>{
        const token = localStorage.getItem('token');
        const payload = {
            token: token,
            // client_id: clientId,
            is_percentage: valueType,
            is_active: isActive==true ? 1 : 0,
        };
        if(value!=""){
            payload.value = value;
        }
        if(driverCut!=""){
            payload.driver_cut = driverCut;
        }
        if(waitingTime!=""){
            payload.waiting_time = waitingTime;
        }
        if(noShowId!=0){
            payload.id = noShowId;
        }

        try {
            const url = operationsUrl + '/driver/update_no_show_setting';
            const response = await makePostRequestToUrl(url,payload);
            if (response.flag === 200) {
                setMessage(response.message)
                showSnackbar(true);
            }
            else if(response.flag==102){
                console.log('Token is expired. Please login again')
                localStorage.removeItem('token');
                setTokenExpired(true);

                setTimeout(() => {
                    navigate('/signup');
                }, 2000);
            }
            else {
                setMessage(response.message)
                showSnackbar(true);
            }

        } catch (error) {
            setMessage(error);
        }
    }

    const handleSnackbarClose = (event, reason) => {
        if (reason === 'clickaway') {
            return; 
        }
        showSnackbar(false); 
    };

    const handleNonNegative = (setter, isValueField = false) => (e) => {
        const value = e.target.value;
        if (value === '') {
            setter('');
            return;
        }
        const n = Number(value);
        if (Number.isNaN(n)) {
            return;
        }
        // For value field, check if it's percentage and above 100
        if (isValueField && valueType == 1 && n > 100) {
            setter('100');
            return;
        }
        setter(n < 0 ? String(Math.abs(n)) : value);
    };

    // Shared handlers to prevent negative input in number fields
    const preventNegativeKey = (e) => {
        if (e.key === '-' || e.key === 'e' || e.key === 'E' || e.key === '+') {
            e.preventDefault();
        }
    };

    return(
        <div> 
            {tokenExpired && (<TokenError/>)}

            <Typography style={{ fontSize: '28px', fontWeight: '500' }}>Settings</Typography>

            <Typography style={{ color: "#83888E" }}>Settings / No Show Settings</Typography>

            <Grid2 sx={{margin:"4px", backgroundColor:"#fff", borderRadius:'8px', padding:'12px', marginTop:'12px'}}>
                <Typography sx={{color:'#4E545D', fontSize:'24px'}}>No Show Settings</Typography>
                <Grid2 container item sx={{border:'1px solid #D1D5DB', marginTop:'18px', borderRadius:'12px', padding:'6px 12px', alignItems:'center'}}>
                    <Grid2 item ><Typography>No Show</Typography></Grid2>
                    <Grid2 item sx={{marginLeft:'auto'}}>
                        <Button
                            variant="contained" onClick={() => setIsActive(true)} 
                            style={{ backgroundColor: isActive ? '#0DBA78' : '#F4F4F4', color: isActive ? '#FFFFFF' : '#9E9E9E',textTransform: 'none',
                                borderRadius: '8px 0 0 8px',boxShadow: 'none',padding: '6px 16px',minWidth: '80px'}}>
                            Enable
                        </Button>
                        <Button
                            variant="contained" onClick={() => setIsActive(false)} 
                            style={{backgroundColor: !isActive ? '#D14545' : '#F4F4F4',color: !isActive ? '#FFFFFF' : '#9E9E9E',
                                textTransform: 'none',borderRadius: '0 8px 8px 0',boxShadow: 'none',padding: '6px 16px', minWidth: '80px',
                            }}>
                            Disable
                        </Button>
                    </Grid2>
                </Grid2>

                <Grid2 item container sx={{marginTop:'24px'}} spacing={4} size={12}>
                    {!Number(driver_no_show_fare_disabled) && 
                        <Grid2 item size={6}>
                            <Label>Driver Cut<span style={{ color: 'red' }}>*</span></Label>
                            <TextField  sx={{marginTop:'2%', color:'#1A1E25'}}
                                placeholder="Driver Cut" fullWidth variant="outlined" type="text" 
                                value={driverCut}
                                onChange={handleNonNegative(setDriverCut)}
                                onKeyDown={preventNegativeKey}
                                InputProps={{
                                    inputProps: { min: 0 },
                                    style: {height: '50px',fontSize: '16px',padding: '8px 14px',backgroundColor: '#FFFFFF'}
                                }}
                            />
                        </Grid2>
                    }
                    {/* {Number(driver_no_show_fare_disabled)==1 &&  */}
                        <Grid2 item size={6}>
                            <Label>Waiting Time (minutes)<span style={{ color: 'red' }}>*</span></Label>
                            <TextField  sx={{marginTop:'2%', color:'#1A1E25'}}
                                placeholder="Waiting Time" fullWidth variant="outlined" type="text" 
                                value={waitingTime}
                                onChange={handleNonNegative(setWaitingTime)}
                                onKeyDown={preventNegativeKey}
                                InputProps={{
                                    inputProps: { min: 0 },
                                    style: {height: '50px',fontSize: '16px',padding: '8px 14px',backgroundColor: '#FFFFFF'}
                                }}
                            />
                        </Grid2>
                    {/* } */}

                    {!Number(driver_no_show_fare_disabled) && 
                        <Grid2 item size={6}>
                            <Label>Value Type<span style={{ color: 'red' }}>*</span></Label>
                            <Select sx={{marginTop:'2%'}}
                                value={valueType} fullWidth
                                onChange={(e) => {
                                    setValueType( e.target.value)
                                    if(e.target.value==1 && value>100){
                                        setValue(100);
                                    }
                                }}
                                style={{ height: '50px', borderRadius: '8px', backgroundColor: '#FFFFFF'}}>
                                    <MenuItem value="1">Percentage</MenuItem>
                                    <MenuItem value="0">Fixed</MenuItem>
                            </Select>
                        </Grid2>
                    }

                    {!Number(driver_no_show_fare_disabled) && 
                        <Grid2 item size={6}>
                            <Label>Value {valueType ==1 ? '(in %)' : ''}<span style={{ color: 'red' }}>*</span></Label>
                            <TextField  sx={{marginTop:'2%', color:'#1A1E25'}}
                                placeholder={`Value ${valueType==1 ? '(in %)' : ''}`} fullWidth variant="outlined" type="text" 
                                value={value}
                                onChange={handleNonNegative(setValue, true)}
                                onKeyDown={preventNegativeKey}
                                InputProps={{
                                    inputProps: { min: 0 },
                                    style: {height: '50px',fontSize: '16px',padding: '8px 14px',backgroundColor: '#FFFFFF'}
                                }}
                            />
                        </Grid2>
                    }
                </Grid2>

                {/* <Grid2 item container sx={{marginTop:'24px'}} spacing={4} size={12}>
                    
                </Grid2> */}


                <Grid2 item sx={{marginTop:'24px', alignItems:'center', justifyContent:'center', display:'flex', marginBottom:'24px'}} size={12}>
                    
                        <Button onClick={saveData} variant="contained">Update</Button>
                    
                </Grid2>
            </Grid2>

            <Snackbar open={snackbar} autoHideDuration={2000} onClose={handleSnackbarClose} message={message}></Snackbar>

        </div>
    )
}

export default NoShowSettings;